import { createFileRoute } from '@tanstack/react-router';
import { DisclosureAndConsentsPage } from '@/features/cleaner/apply-cleaner/disclosure-and-consents-checkr-embed/page';

export const Route = createFileRoute('/checkr/disclosure-consent-embed')({
  component: DisclosureAndConsentsPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: (search.token as string) || undefined,
      status: (search.status as string) || undefined,
    };
  },
});
